export const _LOAD_MODEL_ = 'Load:repor';

export const TOTAL_ITEMS = { total_cash: 'R$ 0', total_term: 'R$ 0', grand_total: 'R$ 0' };
